import { render, staticRenderFns } from "./sceneDetail.vue?vue&type=template&id=5ad7a32a"
import script from "./sceneDetail.vue?vue&type=script&lang=js"
export * from "./sceneDetail.vue?vue&type=script&lang=js"
import style0 from "./sceneDetail.vue?vue&type=style&index=0&id=5ad7a32a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports